import { useMemo } from 'react';
import { useFormState } from 'react-final-form';
import { Customer } from 'data/firestore/agent/customer/types';
import useCustomer from 'data/firestore/agent/customer/use';
import InvoiceDocumentView from '../InvoiceDocumentView';
import { InvoiceBuilderTemplate } from '../types';
import { buildDraftInvoice } from '../helpers';
import { LineDraft } from './LineItemsInput';

interface PreviewProps {
    organizationId: string;
    lockedCustomerId?: string;
}

const Preview = ({ organizationId, lockedCustomerId }: PreviewProps) => {
    const { values } = useFormState();
    const { data: lockedCustomer } = useCustomer(
        organizationId,
        lockedCustomerId || '',
        { disabled: !lockedCustomerId },
    );
    const template = values.template as InvoiceBuilderTemplate | undefined;
    const customer = (lockedCustomerId ? lockedCustomer : values.customer) as Customer | null;
    const invoice = useMemo(() => {
        if (!template) return null;
        return buildDraftInvoice({
            template,
            customer,
            issuedOn: values.issuedOn as Date | undefined,
            dueOn: values.dueOn as Date | undefined,
            lines: (values.lines as LineDraft[]) || [],
            billToCustomValues: (values.billToCustomValues as Record<string, unknown>) || {},
            notes: String(values.notes || ''),
        });
    }, [
        template,
        customer,
        values.issuedOn,
        values.dueOn,
        values.lines,
        values.billToCustomValues,
        values.notes,
    ]);

    if (!invoice) return null;

    return <InvoiceDocumentView invoice={invoice} organizationId={organizationId} />;
};

export default Preview;
